(function () {
  var waitForInit = function () {
    if (window.artov5) {
      var artov5 = window.artov5;
      var api = artov5.api;
      var modelConfig = setModelConfig(window.Speculator.config);

      function setModelConfig(config) {
        if (!config?.model) return;

        return (artov5.modelConfig = {
          pathToModel: `${window.Speculator.baseUrl}/static-artov5/${config.model}.artov5`,
          pathToTextures: `${window.Speculator.baseUrl}/textures/`,
          materialConfig: {
            scale: 0.94,

            bow_l_outer: config.bow_l_outer,
            bow_r_outer: config.bow_r_outer,
            front: config.front,

            glass: config.glass,

            // aldenham, barlow, bemerton

            bow_l_inner: config.bow_l_inner,
            bow_r_inner: config.bow_r_inner,
            front_inner: config.front_inner,

            // beaconsfield, bingfield, collier gifford, keystone,
            // twyford, wynford

            nose_pads: config.nose_pads,

            // camley, collier, grafton

            bow_l_rest: config.bow_l_rest,
            bow_l_logo: config.bow_l_logo,
            bow_l_logo_rest: config.bow_l_logo_rest,
            bow_r_rest: config.bow_r_rest,
            bow_r_logo: config.bow_r_logo,
            bow_r_logo_rest: config.bow_r_logo_rest,

            // ridley, somers

            front_inner_logo: config.front_inner_logo,
          },
        });
      }

      api.set3DModelConfig(modelConfig);

      window.Speculator.set3DModelConfig = function set3DModelConfig(config) {
        if (config.model) {
          modelConfig = setModelConfig(config);
        } else if (config.glass) {
          modelConfig.materialConfig.glass = config.glass;
          window.Speculator.config.glass = config.glass;
        } else {
          modelConfig.materialConfig.bow_l_outer = config;
          modelConfig.materialConfig.bow_r_outer = config;
          modelConfig.materialConfig.front = config;
        }

        api.set3DModelConfig(modelConfig);
      };
    } else {
      setTimeout(waitForInit, 100);
    }
  };

  waitForInit();
})();
